function toggleMenu() { 
    const menuOverlay = document.getElementById('mobile-menu-overlay');
    const isActivating = !menuOverlay.classList.contains('active');
    
    menuOverlay.classList.toggle('active'); 
    document.body.classList.toggle('menu-blur-active');
    
    if (isActivating) {
        setTimeout(() => {
            document.addEventListener('click', closeMenuOnOutsideClick);
        }, 10);
    } else {
        document.removeEventListener('click', closeMenuOnOutsideClick);
    }
}

function closeMenuOnOutsideClick(event) {
    const menuOverlay = document.getElementById('mobile-menu-overlay');
    if (!menuOverlay.contains(event.target)) {
        toggleMenu();
    }
}

function toggleSearch() { 
    const searchOverlay = document.getElementById('search-overlay');
    const isActivating = !searchOverlay.classList.contains('active');
    
    searchOverlay.classList.toggle('active'); 
    document.body.classList.toggle('search-blur-active');
    
    // Add or remove event listener for outside click
    if (isActivating) {
        // Small timeout to prevent the current click from instantly closing it
        setTimeout(() => {
            document.addEventListener('click', closeSearchOnOutsideClick);
        }, 10);
    } else {
        document.removeEventListener('click', closeSearchOnOutsideClick);
    }
}

function closeSearchOnOutsideClick(event) {
    const searchOverlay = document.getElementById('search-overlay');
    // If the click isn't inside the overlay, close it
    if (!searchOverlay.contains(event.target)) {
        toggleSearch();
    }
}

function toggleFaq(el) { 
    el.classList.toggle('active'); 
}
document.addEventListener('DOMContentLoaded', () => {
    const numFlowers = 12; 
    const body = document.body;
    
    for (let i = 0; i < numFlowers; i++) {
        const flower = document.createElement('div');
        flower.classList.add('draggable-flower');
        
        const size = 60 + Math.random() * 60;
        flower.style.width = `${size}px`;
        flower.style.height = `${size}px`;

        const top = Math.random() * 92; 
        const left = Math.random() * 92;
        
        flower.style.top = `calc(${top}% - ${size/2}px)`;
        flower.style.left = `calc(${left}% - ${size/2}px)`;
        
        flower.innerHTML = `
            <svg class="flower-svg" viewBox="0 0 100 100" style="width: 100%; height: 100%; color: var(--pastel-pink); animation: float-flower 10s ease-in-out infinite alternate; animation-delay: -${Math.random() * 10}s;">
                <circle cx="50" cy="36" r="18" fill="currentColor" />
                <circle cx="68" cy="48" r="18" fill="currentColor" />
                <circle cx="60" cy="68" r="18" fill="currentColor" />
                <circle cx="40" cy="68" r="18" fill="currentColor" />
                <circle cx="32" cy="48" r="18" fill="currentColor" />
                <circle cx="50" cy="53" r="15" fill="var(--bright-yellow)" />
            </svg>
        `;
        body.appendChild(flower);
        
        makeDraggable(flower);
    }
});

function makeDraggable(elmnt) {
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    
    elmnt.onmousedown = dragMouseDown;
    elmnt.ontouchstart = dragMouseDown;

    function dragMouseDown(e) {
        e = e || window.event;
        if(e.type !== "touchstart") e.preventDefault();
        
        if (e.type === "touchstart") {
            pos3 = e.touches[0].clientX;
            pos4 = e.touches[0].clientY;
        } else {
            pos3 = e.clientX;
            pos4 = e.clientY;
        }
        
        document.addEventListener('mouseup', closeDragElement);
        document.addEventListener('mousemove', elementDrag);
        document.addEventListener('touchend', closeDragElement);
        document.addEventListener('touchmove', elementDrag, {passive: false});
        
        elmnt.style.cursor = 'grabbing';
        elmnt.style.zIndex = 100; 
    }

    function elementDrag(e) {
        e = e || window.event;
        if(e.type === "touchmove") e.preventDefault();
        
        let clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
        let clientY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;

        pos1 = pos3 - clientX;
        pos2 = pos4 - clientY;
        pos3 = clientX;
        pos4 = clientY;
        
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        document.removeEventListener('mouseup', closeDragElement);
        document.removeEventListener('mousemove', elementDrag);
        document.removeEventListener('touchend', closeDragElement);
        document.removeEventListener('touchmove', elementDrag);
        elmnt.style.cursor = 'grab';
        elmnt.style.zIndex = ''; 
    }
}

function openImageViewer(url) {
    const viewer = document.getElementById('image-viewer');
    const img = document.getElementById('viewer-img');
    img.src = url;
    img.classList.remove('zoomed');
    img.style.transform = '';
    viewer.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scroll
    
    // Toggle zoom on image click
    img.onclick = function(e) {
        e.stopPropagation();
        this.classList.toggle('zoomed');
        if (!this.classList.contains('zoomed')) {
            this.style.transform = '';
        }
    };
    
    // Pan logic when zoomed
    viewer.onmousemove = function(e) {
        if (img.classList.contains('zoomed')) {
            const x = e.clientX / window.innerWidth;
            const y = e.clientY / window.innerHeight;
            
            // Adjust translation based on mouse position
            const moveX = (0.5 - x) * 50; 
            const moveY = (0.5 - y) * 50;
            
            img.style.transform = `scale(1.5) translate(${moveX}%, ${moveY}%)`;
        }
    };
}

function closeImageViewer() {
    const viewer = document.getElementById('image-viewer');
    viewer.classList.remove('active');
    document.body.style.overflow = ''; // Restore scroll
    const img = document.getElementById('viewer-img');
    if (img) {
        img.classList.remove('zoomed');
        img.style.transform = '';
    }
}
